import { render, staticRenderFns } from "./PaymentCardsSlider.vue?vue&type=template&id=01167126"
import script from "./PaymentCardsSlider.vue?vue&type=script&lang=js"
export * from "./PaymentCardsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports